import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox, Paper } from "@mui/material";

import { useAdministrationContext } from "./administration_context";
import { post } from "../../lib/api";
import { useAlertContext } from "../Page/alert_context";

const PageManager = () => {
  const { user } = useAdministrationContext();
  const [pages, setPages] = useState([]);
  const [userPages, setUserPages] = useState([]);

  const { showAlert } = useAlertContext();

  useEffect(() => {
    const fetchData = async () => {
      const allPages = await post({ method: "getPages" });
      const userSpecificPages = await post({ method: "getPagesOfUser", user_id: user[0] });

      setPages(allPages);
      setUserPages(userSpecificPages);
    };

    fetchData();
  }, [user]);

  const isPageChecked = (page) => {
    return userPages.some((userPage) => JSON.stringify(userPage) === JSON.stringify(page));
  };

  const handleCheckboxChange = async (page) => {
    // Determine whether to add or remove a page for the user.
    const method = isPageChecked(page) ? "removePage" : "addPage";
    const data = {
      method,
      parent_id: page.parent_id, // Assuming page structure includes parent_id.
      page_id: page.page_id, // Assuming page structure includes page_id.
      version_id: page.version_id, // Assuming page structure includes version_id.
      user_id: user[0], // User ID to which the page is being assigned or removed.
      game_id: page.game_id, // Assuming page structure includes game_id.
    };

    await post(data); // Send request to add or remove page access.

    // Display appropriate alert depending on whether page was added or removed.
    if (method === "addPage") {
      showAlert(
        <span>
          Added access to page <strong>{page[1]}</strong> for user <strong>{user[1]}</strong>! (ID: {user[0]})
        </span>,
        "success"
      );
    } else {
      showAlert(
        <span>
          Removed access to page <strong>{page[1]}</strong> for user <strong>{user[1]}</strong>! (ID: {user[0]})
        </span>,
        "warning"
      );
    }

    // Update 'userPages' state based on whether the page was added or removed.
    const updatedUserPages =
      method === "addPage"
        ? [...userPages, page] // Add the page to the user's assigned pages.
        : userPages.filter((userPage) => JSON.stringify(userPage) !== JSON.stringify(page)); // Remove the page from user's assigned pages.

    setUserPages(updatedUserPages); // Update state with new list of user pages.
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox"></TableCell>
            <TableCell>Game</TableCell>
            <TableCell>Variant</TableCell>
            <TableCell>Game ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {/* Table body containing rows of pages. */}
          {pages.map((page, index) => (
            <TableRow key={index}>
              {/* Map through pages and create a row for each page. */}
              <TableCell padding="checkbox">
                <Checkbox
                  className="custom-checkbox" // Custom styling for the checkbox.
                  checked={isPageChecked(page)} // Determine if the checkbox should be checked.
                  onChange={() => handleCheckboxChange(page)} // Handle checkbox changes for adding/removing access.
                />
              </TableCell>
              <TableCell>
                {page.parent_id} {page.page_id}
              </TableCell>
              {/* Display Game information. */}
              <TableCell>{page.version_id}</TableCell> {/* Display Variant information. */}
              <TableCell align={"center"}>{page.game_id}</TableCell> {/* Display Game ID, centered. */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PageManager;
